import type { SVGProps } from 'react';
const DawnFlagMK = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-MK_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-MK_svg__a)">
      <path fill="#E81B26" d="M0 0h22v16H0z" />
      <path
        fill="#FFE94F"
        fillRule="evenodd"
        d="M11 10.667c1.446 0 2.619-1.194 2.619-2.667s-1.173-2.667-2.62-2.667C9.554 5.333 8.382 6.527 8.382 8S9.553 10.667 11 10.667M8.02 5.823q.239-.338.543-.612L1.54-2.824-.562-.446zm.543 4.966a3.7 3.7 0 0 1-.542-.612l-8.583 6.27 2.103 2.378zM7.37 8.53a3.8 3.8 0 0 1 0-1.057L0 6.4v3.2zm2.91-4.19L9.43 0h3.143l-.853 4.339a3.6 3.6 0 0 0-1.438 0m4.35 3.133a3.8 3.8 0 0 1 0 1.056L22 9.6V6.4zm-4.35 4.19L9.43 16h3.143l-.853-4.338a3.6 3.6 0 0 1-1.438 0m3.157-.873 7.022 8.036 2.103-2.378-8.583-6.27q-.238.337-.542.612m0-5.578q.304.275.543.612l8.582-6.27-2.103-2.377z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagMK;
